import $ from 'jquery';
import { sessionStorageGetItem, sessionStorageSetItem } from './storage_helpers';

const notificationBarDismissed = key => sessionStorageGetItem(key);
const referralModalDismissed = () => sessionStorageGetItem('referralModalDismissed');
const partnerReferralModalDismissed = () => sessionStorageGetItem('partnerReferralModalDismissed');

const dispatchNotificationBarEvent = () =>
  window.dispatchEvent(new CustomEvent('notification-bar-change'));

const notificationBarStorageKey = () => {
  const notificationBar = document.getElementById('notification-bar-close');
  return notificationBar ? notificationBar.dataset.storageKey : false;
};

const showNotificationBar = () =>
  $('#notification-bar').removeClass('hide') && dispatchNotificationBarEvent();

const listenForReferralModalSubmit = () => {
  $('input#company_lead_email').keypress(e => {
    if (e.which === 13) {
      e.preventDefault();
      $('form#referral-modal-form').submit();
    }
  });
};

const listenForPartnerReferralModalSubmit = () => {
  $('input#accountant_lead_email').keypress(e => {
    if (e.which === 13) {
      e.preventDefault();
      $('form#partner-referral-modal-form').submit();
    }
  });
};

const showReferralModal = () => {
  $('.referral-overlay').removeClass('hide');
  listenForReferralModalSubmit();
};

const hideReferralModal = () => {
  $('.referral-overlay').addClass('hide');
  showNotificationBar();
  sessionStorageSetItem('referralModalDismissed', 'true');
};

const showPartnerReferralModal = () => {
  $('.partner-referral-overlay').removeClass('hide');
  listenForPartnerReferralModalSubmit();
};

const hidePartnerReferralModal = () => {
  $('.partner-referral-overlay').addClass('hide');
  sessionStorageSetItem('partnerReferralModalDismissed', 'true');
};

const showReferralTerms = () => {
  $('.referral-terms-container').removeClass('hide');
  $('.referral-main-content-container').addClass('hide');
};

const showPartnerReferralTerms = () => {
  $('.partner-referral-terms-container').removeClass('hide');
  $('.referral-main-content-container').addClass('hide');
};

const handleNotificationBarVisibility = () => {
  const storageKey = notificationBarStorageKey();
  if (storageKey === window.NOTIFICATION_BAR_STORAGE_KEYS.REFEREE) {
    if (referralModalDismissed() && !notificationBarDismissed(storageKey)) {
      showNotificationBar();
    }
  } else if (!notificationBarDismissed(storageKey)) {
    showNotificationBar();
  }
};

const handleNotificationBarClose = () => {
  $('#notification-bar').addClass('hide');
  sessionStorageSetItem(notificationBarStorageKey(), 'true');
  dispatchNotificationBarEvent();
};

$(document).on('click', '#referral-modal-close', hideReferralModal);
$(document).on('click', '#partner-referral-modal-close', hidePartnerReferralModal);
$(document).on('click', '#notification-bar-close', handleNotificationBarClose);

// TODO: Don't scroll back to the top of the page
$(document).on('click', '#referral-terms-overlay', showReferralTerms);
$(document).on('click', '#partner-referral-terms-overlay', showPartnerReferralTerms);

$(document).on('click', '#referral-modal-terms-close', () => {
  $('.referral-terms-container').addClass('hide');
  $('.referral-main-content-container').removeClass('hide');
});

$(document).on('click', '#partner-referral-modal-terms-close', () => {
  $('.partner-referral-terms-container').addClass('hide');
  $('.referral-main-content-container').removeClass('hide');
});

$(document).ready(() => {
  // Backend determines if the modal gets put on the DOM
  if (!referralModalDismissed()) {
    showReferralModal();
  }

  // Backend determines if the modal gets put on the DOM
  if (!partnerReferralModalDismissed()) {
    showPartnerReferralModal();
  }

  handleNotificationBarVisibility();
});
